import * as React from 'react';
import {FC} from 'react';
import {Create, CreateProps, SelectInput, SimpleForm, TextInput, ReferenceInput, NumberInput} from 'react-admin';
import Title from "../../../components/list/Title";
import {listEditCreate} from "../../../styles/listEditCreate";
import {filterProps} from "../../../functions/common";

const PriceMatrixCreate: FC<CreateProps> = props => {
    const classes = listEditCreate();
    const newProps = filterProps(props);

    return (
        <Create {...newProps}>
            <SimpleForm className={classes.sidebar}>
                <Title label="resources.admin/lod-raw-material-prices.titles.create" />
                <TextInput source="matnr" fullWidth={true} />
                <TextInput source="designation" fullWidth={true}/>
                <ReferenceInput label="resources.admin/lod-price-matrix.fields.material" source="material_id" reference="admin/lod-materials" options={{
                    suggestionsContainerProps: {
                        disablePortal: true,
                    }
                }} filter={{status: 'active'}}>
                    <SelectInput optionText="name_lt" fullWidth={true}/>
                </ReferenceInput>
                <ReferenceInput label="resources.admin/lod-raw-material-prices.fields.thickness" source="thickness_id" reference="admin/lod-thickness" options={{
                    suggestionsContainerProps: {
                        disablePortal: true,
                    }
                }} filter={{status: 'active'}}>
                    <SelectInput optionText="name_lt" fullWidth={true} />
                </ReferenceInput>
                <ReferenceInput label="resources.admin/lod-raw-material-prices.fields.color" source="color_id" reference="admin/lod-colors" options={{
                    suggestionsContainerProps: {
                        disablePortal: true,
                    }
                }} filter={{status: 'active'}}>
                    <SelectInput optionText="name_lt" fullWidth={true} />
                </ReferenceInput>
                <ReferenceInput label="resources.admin/lod-raw-material-prices.fields.foil" source="foil_id" reference="admin/lod-foils" options={{
                    suggestionsContainerProps: {
                        disablePortal: true,
                    }
                }} filter={{status: 'active'}}>
                    <SelectInput optionText="name_lt" fullWidth={true} />
                </ReferenceInput>
                <NumberInput source="price" fullWidth={true} />
            </SimpleForm>
        </Create>
    );
};

export default PriceMatrixCreate;
